<h2 mat-dialog-title>CodeSnippets Connection</h2>
<mat-dialog-content>

  <mat-tab-group>

    <mat-tab label="Screens">
      <data-table
        (detail)="onDetailScreenSettings($event)"
        (remove)="onRemoveFromScreenSettings($event)"
        [columns]="columnsScreenSettings"
        [dataProviderParams]="paramsScreenSettingsAdded"
        [dataProvider]="screenSettingsService"
        [title]="'Embedded via Screen Settings'"
      ></data-table>
      <div class="button-right-container">
        <button (click)="removeFromAllScreens()" class="ibexfusion-raised-button" mat-button>Remove from all Screens</button>
      </div>
    </mat-tab>

    <mat-tab label="Add to Screen">
      <data-table
        (custom)="onAddToScreenSettings($event)"
        [columns]="columnsScreenSettings"
        [dataProviderParams]="paramsScreenSettings"
        [dataProvider]="screenSettingsService"
        [title]="'Available Screens'"
        icon="add_circle"
      ></data-table>
    </mat-tab>


    <mat-tab label="Compositions">
      <data-table
        (detail)="onDetailComposition($event)"
        [columns]="columnsComposition"
        [dataProviderParams]="paramsComposition"
        [dataProvider]="compositionService"
        [title]="'Embedded via Compositions'"
      ></data-table>
    </mat-tab>

    <mat-tab label="Legacy Compositions">
      <data-table
        (detail)="onDetailLegacyComposition($event)"
        [columns]="columnsLegacyComposition"
        [dataProviderParams]="paramsLegacyComposition"
        [dataProvider]="legacyCompositionService"
        [title]="'Embedded via Legacy Compositions'"
      ></data-table>
    </mat-tab>

    <mat-tab label="Config Custom JSON's ">
      <data-table
        (detail)="onDetailJsons($event)"
        [columns]="columnsJsons"
        [dataProviderParams]="paramsJsons"
        [dataProvider]="jsonService"
        [title]="'Embedded via Custom Json'"
      ></data-table>
    </mat-tab>

  </mat-tab-group>

</mat-dialog-content>

